import cx from "classnames";

// CSS
import styles from "./chip.module.scss";

const Chip = (props) => {
    const { isSelected, onClick, text } = props;

    return (
        <div
            className={cx(styles.chip, {
                [styles["chip--selected"]]: isSelected,
            })}
            onClick={onClick}
        >
            <span className={styles.text}>{text}</span>
        </div>
    );
};

export default Chip;
